import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/user";

export const Store = configureStore({
    reducer: {
        user: userSlice.reducer
    }
})

